
import { useEffect, useState } from 'react'
import { URL_BACKEND } from '../../api/url';
import { sortDirections } from '../../data/datos';

export const useCorreosEnviados = () => {

    const [data, setData] = useState([])
    const [textoBuscar, setTextoBuscar] = useState("")
    const [datosAspirantes, setDatosAspirantes] = useState([])
    const [loading, setLoading] = useState( true )


    // funciones
    const traerCorreosEnviados = () => {

        let datos = new FormData()
        datos.append('funcion', 'correosenviados');

        fetch( URL_BACKEND, {
            method: 'post',
            body: datos
        })
        .then( res => res.json() )
        .then( function( d ){
            setDatosAspirantes( d )
            setData( d )
        })
        .finally(() => setLoading( false ))
    }

    const filtrar = ( cosaABuscar ) => {

        cosaABuscar = cosaABuscar.trim()

        if (cosaABuscar) {
            // aquí haremos una búsqueda porque el usuario escribió algo
            var resultadosNuevos = data.filter( function( elemento ){

                let busqueda = new RegExp( cosaABuscar, 'gi' )
                if ( busqueda.test( elemento.nombre )
                    || busqueda.test( elemento.prematricula )
                    || busqueda.test( elemento.ciclo_examen )
                    || busqueda.test( elemento.celular )
                    || busqueda.test( elemento.correo )
                    || busqueda.test( elemento.hora_envio )
                    || busqueda.test( elemento.tipo ) ) {
                    return true
                } else {
                    return false
                }

            })
            setDatosAspirantes( resultadosNuevos )

        } else {
            // aquí no haremos la búsqueda, pero devolvemos todos los elementos
            setDatosAspirantes( data )
        }
    }

    // useEffects

    useEffect(() => {
        traerCorreosEnviados()
    }, [])

    useEffect(() => {

        filtrar( textoBuscar )

    }, [ textoBuscar ])


    // algo del buscador


    // las columnas de la tabla
    const columns = [
        {
            title: 'Prematrícula',
            dataIndex: 'prematricula',
            sortDirections
        },
        {
            title: 'Nombre',
            dataIndex: 'nombre',
            sortDirections
        },
        {
            title: 'Ciclo examen',
            dataIndex: 'ciclo_examen',
            sortDirections
        },
        {
            title: 'Teléfono',
            dataIndex: 'celular'
        },
        {
            title: 'Correo',
            dataIndex: 'correo',
            sortDirections
        },
        {
            title: 'Hora de envío',
            dataIndex: 'hora_envio',
            sortDirections
        },
        {
            title: 'Tipo de correo',
            dataIndex: 'tipo',
            sortDirections
        }
    ];


    return {
        columns,
        datosAspirantes,
        loading,
        textoBuscar,
        setTextoBuscar
    }

}
